export default function IDisabled({ width = 32, height = 32, color = "#686A68", ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none">
            <path d="M27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16ZM29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z" fill={color} />
            <path d="M25.3737 23.9596L23.9596 25.3737L6.6263 8.04036L8.04036 6.6263L25.3737 23.9596Z" fill={color} />
        </svg>
    );
}